import React from 'react';
import PropTypes from 'prop-types';
import { Box, TableContainer, Paper, Table, TableHead, TableRow, TableBody, alpha } from '@mui/material';
import { StyledTableCell } from './StyledComponents';
import DesktopWatchListRow from './DesktopWatchListRow';

const DesktopWatchList = ({ filteredItems, toggleDrawer }) => (
  <Box sx={{
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }}>
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 0,
        boxShadow: 'none',
        overflow: filteredItems.length > 5 ? 'auto' : 'visible',
        height: '100%',
        margin: 0,
        padding: 0,
        width: '100%',
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar': { width: 6 },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.3),
          borderRadius: 3
        }
      }}
    >
      <Table stickyHeader>
        {filteredItems.length > 0 && (
          <>
            <TableHead sx={{
              position: 'sticky',
              top: 0,
              zIndex: 1050,
              backgroundColor: (theme) => theme.palette.mode === 'light'
                ? theme.palette.background.neutral
                : theme.palette.grey[800],
            }}>
              <TableRow>
                <StyledTableCell>Symbol</StyledTableCell>
                <StyledTableCell align="center">Bid</StyledTableCell>
                <StyledTableCell align="center">Ask</StyledTableCell>
                <StyledTableCell align="right">LTP</StyledTableCell>
                <StyledTableCell align="right">Change</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{
              '& tr': {
                display: 'table-row'
              },
              '& tr:not(:last-child) td': {
                paddingBottom: '16px',
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`
              }
            }}>
              {filteredItems.map((item) => (
                <DesktopWatchListRow
                  key={item._id}
                  item={item}
                  onClick={toggleDrawer}
                />
              ))}
            </TableBody>
          </>
        )}
      </Table>
    </TableContainer>
  </Box>
);

DesktopWatchList.propTypes = {
  filteredItems: PropTypes.array.isRequired,
  toggleDrawer: PropTypes.func.isRequired
};

export default DesktopWatchList;
